// Transmitter families are identified by product-level `parentFamilies` metadata.
export class TransmitterType {
  static fromFamilyName(name: string, cantoImageId = ""): TransmitterType {
    return new TransmitterType(name, TransmitterType.toKey(name), cantoImageId);
  }

  static fromKey(key: string): TransmitterType {
    return new TransmitterType(key.replaceAll("_", " "), key, "");
  }

  private static toKey(name: string): string {
    return name.trim().replaceAll(/[^\p{L}\p{N}]+/gu, "_");
  }

  constructor(
    public name: string,
    public key: string,
    public cantoImageId: string,
  ) {}
}
